export default {
  'component.tagSelect.expand': '펼치기',
  'component.tagSelect.collapse': '접기',
  'component.tagSelect.all': '전체',
};
